import React, { useMemo, useImperativeHandle, forwardRef } from 'react';
import { Button, withStyles, Typography, Hidden } from '@material-ui/core';
import classNames from 'classnames';
import { useDropzone } from 'react-dropzone';
import UpArrow from 'aurora-images/UpArrow.svg';
import uploadImg from 'aurora-images/uploadImg.svg';
import PropTypes from 'prop-types';
import { keyEmptyCheck } from 'aurora-utils/utils';
import styles from './styles';

const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: 230,
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  //   borderBottom: '3px dashed #000',
  backgroundColor: '#F9FBFF',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out',
};
const focusedStyle = {
  borderColor: '#2196f3',
};
const acceptStyle = {
  borderColor: '#009f9f',
  background: '#EBEEF3',
};
const rejectStyle = {
  borderColor: '#ff1744',
};

const UploadComponent = forwardRef((props, ref) => {
  const {
    classes,
    customClass,
    hideUploadSection,
    title,
    desription,
    hoverTooltip,
    maxFiles,
    maxSize,
    fileType,
    handleChange,
  } = props;
  const FILETYPES = {
    IMAGE: { 'image/*': ['.png', '.jpeg', '.jpg'] },
    PDF: { 'application/pdf': ['.pdf'] },
    ZIP: { 'application/zip': ['.zip'] },
    XLSX: {
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx', '.xls'],
    },
  };
  const { getRootProps, isFocused, isDragAccept, isDragReject, open, getInputProps } = useDropzone({
    maxFiles: maxFiles || 1,
    maxSize: maxSize || 1000000, // 1000000 1MB
    accept: fileType ? FILETYPES[fileType] : FILETYPES.IMAGE,
    onDrop: (acceptedFiles, fileRejections) => {
      handleChange && handleChange({ acceptedFiles, fileRejections });
    },
  });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject],
  );

  useImperativeHandle(ref, () => ({
    showAlert() {
      open();
    },
  }));
  return (
    <div>
      <div className={classes.uploaderContainer}>
        <div
          className={classNames([classes.dragContainer, customClass, hideUploadSection && classes.hideUploadSection])}
          {...getRootProps({ style })}
        >
          <input {...getInputProps()} />
          {isDragAccept ? (
            <>
              <img src={UpArrow} alt='uparrow' />
              <Typography className={classes.dropFileText}>{keyEmptyCheck(hoverTooltip)}</Typography>
            </>
          ) : (
            <>
              <>
                <Button
                  className={classes.uploadButton}
                  //  onClick={openDropzone}
                  variant='outlined'
                  startIcon={<img src={uploadImg} className={classes.uploadIcon} alt='uparrow' />}
                >
                  {keyEmptyCheck(title)}
                </Button>
                <Hidden xsDown>
                  <Typography className={classes.dragFileText}>{keyEmptyCheck(desription)}</Typography>
                </Hidden>
              </>
            </>
          )}
        </div>
        {/* <input onClick={open} type='button' /> */}
      </div>
    </div>
  );
});
UploadComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  desription: PropTypes.string.isRequired,
  hoverTooltip: PropTypes.string.isRequired,
  maxFiles: PropTypes.number.isRequired,
  maxSize: PropTypes.number.isRequired,
  fileType: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  ref: PropTypes.any.isRequired,
  hideUploadSection: PropTypes.bool,
  customClass: PropTypes.object,
};
UploadComponent.defaultProps = {
  hideUploadSection: false,
  customClass: {},
};
export default withStyles(styles)(UploadComponent);
